import React from 'react';
import ReactOnRails from 'react-on-rails';
import FlashcardProblem from './flashcard-problem';
import FlashcardAnswers from './flashcard-answers';
import WorksheetsControls from '../worksheets/worksheets-controls';

import {
  worksheetProblems,  // Start here
  typeFromURL,
  limitsFromPlaces
} from '../worksheets/lib/math';

const Answer = 0;
const Top = 1;
const Bottom = 2;
const qtyProblems = 6;
const sheetPlaces = 1;

export default class FlashcardCreator extends React.Component {

  constructor(props) {
    super(props);
    const problems = this.setProblems(sheetPlaces, qtyProblems, typeFromURL());
    this.state = {
      sheetType: typeFromURL(),
      sheetPlaces: sheetPlaces,
      qtyProblems: qtyProblems,
      problems: problems,
      correctProblems: this.correctArray()
    };
    this.chooseType.bind(this);
    this.choosePlaces.bind(this);
  }

  setProblems(sheetPlaces, qty, type) {
    const limits = limitsFromPlaces(sheetPlaces);
    const problems = worksheetProblems(type, qty, limits[0], limits[1]);
    return problems;
  }

  correctArray() {
    let correctProblems = new Array(qtyProblems);
    for (var i = 0; i < correctProblems.length; ++i) {
      correctProblems[i] = 0;
    }
    return correctProblems;
  }

  choosePlaces(number) {
    this.setState({
      sheetPlaces: number,
      correctProblems: this.correctArray(),
      problems: this.setProblems(number, qtyProblems, this.state.sheetType)
    });
  }

  chooseType(type) {
    this.setState({
      sheetType: type,
      correctProblems: this.correctArray(),
      problems: this.setProblems(this.state.sheetPlaces, qtyProblems, type)
    });
  }

  setCorrectProblem(index, result) {
    let cp = this.state.correctProblems;
    cp[index] = result;
    this.setState({
      correctProblems: cp
    });
  }

  createProblems() {
    return this.state.problems.map((prob, index) => {
      return (
        <FlashcardProblem
          top={prob[Top]}
          bottom={prob[Bottom]}
          type={this.state.sheetType}
          />
      );
    });
  }

  render() {
    const problems = this.createProblems();

    return (
      <div className="flashcard-creator">
        <div className="row">
          <div className="col-sm-3 col-xs-12">
            <WorksheetsControls
              sheetType={this.state.sheetType}
              sheetPlaces={this.state.sheetPlaces}
              chooseType={this.chooseType.bind(this)}
              choosePlaces={this.choosePlaces.bind(this)}
               />
          </div>
          <div className="col-sm-9 col-xs-12">
            <h1 className="flashcard-creator__print-heading">Front of Print</h1>
            {problems}
          </div>
          <div className="col-sm-9 col-xs-12">
            <FlashcardAnswers
              problems={this.state.problems} />
          </div>
        </div>
      </div>
    );
  }

}
ReactOnRails.register({ FlashcardCreator });



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/flashcard-creator/component.js
 **/